import React, { CSSProperties } from 'react';
import './Loader.scss';
import clsx from 'clsx';
import { Typography } from '@material-ui/core';

interface Props {
    inline?: boolean;
    text?: string;
    opaque?: boolean;
    position?: 'fixed' | 'absolute' | 'relative' | 'static' | 'sticky';
    dotWidth?: string;
    dotHeight?: string;
    dotMargin?: string;
}

function Loader({ inline, text, opaque, position='relative', dotWidth, dotHeight, dotMargin }: Props) {

    const dotStyle: CSSProperties = {
        '--dot-width': dotWidth,
        '--dot-height': dotHeight,
        '--dot-margin': dotMargin,
    } as CSSProperties;

    return (
        <div className={clsx('root', { inline, opaque })} style={{ position }}>
            <div className="container">
                <span className="dot" style={dotStyle} />
                <span className="dot" style={dotStyle} />
                <span className="dot" style={dotStyle} />
            </div>
            {text && (
                <Typography variant="h4" color="primary" className="text">
                    {text}
                </Typography>
            )}
        </div>
    );
}

export default Loader;